import React, { useState } from 'react';

import { Box, Flex, HStack, Square } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { useToggle } from 'react-use';

import { AIServiceIcon, LeftArrowIcon, RightArrowIcon } from 'components/Icons';
import { CustomTooltip } from 'components/index';

export const AiBrainButton = () => {
  const [mouseIn, setMouseIn] = useState(false);
  const [side, toggleSide] = useToggle(false);
  const navigate = useNavigate();

  return (
    <Flex
      pos={'fixed'}
      zIndex={1000}
      bottom={6}
      left={side ? 'auto' : 4}
      right={side ? 4 : 'auto'}
      gap={0}
      onMouseMove={() => setMouseIn(true)}
      onMouseOut={() => {
        setMouseIn(false);
      }}
    >
      <CustomTooltip label="Ask Ariksa AI">
        <HStack>
          {side && (
            <Square
              cursor={'pointer'}
              opacity={mouseIn ? 1 : 0}
              onClick={() => {
                setMouseIn(false);
                toggleSide();
              }}
            >
              <LeftArrowIcon />
            </Square>
          )}
          <Flex px={2}>
            <Box
              aria-label={''}
              bg={'primary'}
              color={'white'}
              boxSize={12}
              p={2.5}
              borderRadius={6}
              cursor="pointer"
              onClick={() => navigate('/home/ai-assistant')}
            >
              <AIServiceIcon />
            </Box>
          </Flex>
          {!side && (
            <Square
              cursor={'pointer'}
              opacity={mouseIn ? 1 : 0}
              onClick={() => {
                setMouseIn(false);
                toggleSide();
              }}
            >
              <RightArrowIcon />
            </Square>
          )}
        </HStack>
      </CustomTooltip>
    </Flex>
  );
};
